import request from './request'

/** 与小程序同源：拉取当前「每日一关」拼图（可能触发服务端 display_date 更新） */
export function fetchDailyTiles() {
  return request({ url: '/api/tiles', method: 'get' })
}

export function fetchDailyPuzzles(params) {
  return request({ url: '/api/daily-puzzles', method: 'get', params })
}

export function reorderDailyPuzzles(ids) {
  return request({
    url: '/api/daily-puzzles/reorder',
    method: 'put',
    data: { ids }
  })
}

/** 当前页在全局中的起始偏移 + 本页 id 顺序 */
export function reorderDailySlice(offset, orderedIds) {
  return request({
    url: '/api/daily-puzzles/reorder-slice',
    method: 'put',
    data: { offset, ordered_ids: orderedIds }
  })
}

/** direction: 'prev' | 'next'（全局上一条 / 下一条） */
export function swapDailyPuzzle(id, direction) {
  return request({
    url: '/api/daily-puzzles/swap',
    method: 'post',
    data: { id, direction }
  })
}

/** @param {FormData} formData — fields: files[] (same name), difficulty */
export function batchUploadDailyPuzzles(formData) {
  return request({
    url: '/api/daily-puzzles/batch',
    method: 'post',
    data: formData
  })
}

export function deleteDailyPuzzle(id) {
  return request({
    url: `/api/daily-puzzles/${encodeURIComponent(id)}`,
    method: 'delete'
  })
}

export function fetchDailyPuzzlePreview(id) {
  return request({
    url: `/api/daily-puzzles/${encodeURIComponent(id)}/preview`,
    method: 'get'
  })
}

/** 保存「猜猜我是谁」四选项与正确答案（option_a~d + correct: a|b|c|d） */
export function saveDailyPuzzleGuessOptions(id, payload) {
  return request({
    url: `/api/daily-puzzles/${encodeURIComponent(id)}/guess-options`,
    method: 'put',
    data: payload
  })
}
